import styled from 'styled-components';

export const Footer = styled.footer`
  background: var(--accent-color-court);
  color: white;
  padding: 0;
  font-family: 'Ubuntu', sans-serif;

  .footer-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 0;
      padding: 0 1rem;
    }
  }

  .footer-contacts,
  .footer-nav {
    border-left: 6px solid rgba(255, 255, 255, 0.75);
    padding: 1.25rem 0 1.25rem 1rem;
  }

  .footer-contacts {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    align-items: flex-start;
  }

  .footer-contact-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;

    strong {
      color: #fbbf24;
      font-size: 0.95rem;
    }

    a, span {
      color: #cbd5e1;
      text-decoration: none;
      transition: all 0.3s ease;
      font-size: 0.95rem;
    }

    a:hover {
      color: #3b82f6;
      transform: translateX(5px);
    }

    .address-link {
      &:hover {
        color: #3b82f6;
        text-decoration: underline;
      }
    }
  }

  .footer-nav-title {
    color: #fbbf24;
    margin-bottom: 0.6rem;
    font-size: 1.05rem;
    font-weight: 600;
  }

  .footer-nav-list {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-nav-item {
    margin: 0;
  }

  .styled-footer-link {
    color: #cbd5e1;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    display: inline-block;

    &:hover {
      color: #3b82f6;
      transform: translateX(5px);
    }
  }

  .footer-social-links {
    display: flex;
    gap: 0.6rem;
    margin-top: 0.4rem;
    flex-wrap: wrap;
  }

  .footer-social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 16px;
    transition: all 0.3s ease;

    svg {
      width: 24px;
      height: 24px;
    }

    &.vk {
      background: #0077FF;
      svg { fill: white; }
      &:hover {
        background: #0066DD;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(0, 119, 255, 0.4);
      }
    }

    &.telegram {
      background: #0088cc;
      svg { fill: white; }
      &:hover {
        background: #0077b5;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(0, 136, 204, 0.4);
      }
    }

    &.yandex-maps {
      background: #FF0000;
      svg { fill: white; }
      &:hover {
        background: #CC0000;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
      }
    }

    @media (max-width: 480px) {
      width: 34px;
      height: 34px;

      svg {
        width: 17px;
        height: 17px;
      }
    }
  }

  .footer-bottom {
    border-top: 6px solid rgba(255, 255, 255, 0.75);
    padding: 0.85rem 0;
    margin-top: 0;
  }

  .footer-bottom-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;

    .copyright {
      color: #9ca3af;
      font-size: 0.9rem;

      .version {
        margin-left: 0.5rem;
        opacity: 0.7;
        font-size: 0.8rem;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 1rem;
      text-align: center;
      justify-content: center;
    }
  }
`;

export default Footer;